<template>
  <el-popover trigger="click" placement="left" :disabled="instructorAjaxing" v-model="showPlaylistActionMenu" :tabindex="-1">
    <div class="action-button">
      <v-btn flat @click="previewPlaylist()" text class="branded-grey">
        <v-icon small class="pr-1">play_circle_outline</v-icon>
        Preview
      </v-btn>
    </div>
    <div
      v-if="!teacherOwnsPlaylist"
      class="action-button">
      <v-btn flat @click="copyPlaylistLink()" text class="branded-grey">
        <v-icon small class="pr-1">link</v-icon>
        Copy
      </v-btn>
    </div>
    <div slot="reference">
      <v-icon
        v-if="actionColumn"
        tabindex="-1"
        class="hover-white cursor padding branded-text mr-2"
        aria-label="playlist action menu">
          more_vert
      </v-icon>
      <v-icon
        v-else
        tabindex="-1"
        class="cursor"
        large
        :color="playlist.defaultColor"
        aria-label="playlist icon">
          playlist_play
      </v-icon>
    </div>
  </el-popover>
</template>

<script>
/* global _ */
import { 
  mapActions,
  mapState,
  mapGetters,
  mapMutations
} from 'vuex';
import Hashids from 'hashids';
const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  name: 'PlaylistPremadeActionMenu',
  props: [
    'actionColumn',
    'playlist',
  ],
  data() {
    return {
      showPlaylistActionMenu: false,
    };
  },
  computed: {
    ...mapState('instructors', [
      'instructorAjaxing',
    ]),
    ...mapGetters([
      'instructorData',
      'LMSdata',
      'LTIdata',
      'LTIlaunch',
      'nodeApiPrefix',
    ]),
    playlistHash() {
      return hashids.encode([this.playlist.id]);
    },
    teacherOwnsPlaylist() {
      return _.get(this.playlist, 'teachers[0].email') === this.instructorData.email;
    },
  },
  methods: {
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal',
    ]),
    copyPlaylistLink() {
      window.open(`${this.nodeApiPrefix}/course/${this.playlistHash}?token=${this.instructorData.token}`, '_blank');
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    previewPlaylist() {
      window.open(`${this.nodeApiPrefix}/course/${this.playlistHash}?token=${this.instructorData.token}&preview=true`, '_blank');
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
  },
};
</script>
